import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewEncapsulation,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ActivatedRoute } from "@angular/router";
import { CommonModule, DatePipe } from "@angular/common";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { v4 as uuidv4 } from "uuid";
import { pluck, lastValueFrom } from "rxjs";
import { Address } from "../../../../core/models/shared/address";
import { CreateAttachmentRequestDto } from "../../../../core/models/shared/createAttachmentRequestDto";
import { FileUploadDto } from "../../../../core/models/shared/fileUploadDto";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { VendorAttachments } from "../../../../core/models/vendor/addVendor/vendorAttachment";
import { BillingRepresentative } from "../../../../core/models/vendor/summary/billingRepresntative";
import { VendorFeedback } from "../../../../core/models/vendor/summary/vendorFeedback";
import { VendorFeedbackDto } from "../../../../core/models/vendor/summary/vendorFeedbackDto";
import { VendorFeedbackRequestDto } from "../../../../core/models/vendor/summary/vendorFeedbackRequestDto";
import { VendorSummaryDto } from "../../../../core/models/vendor/summary/vendorSummaryDto";
import { AddNewClientService } from "../../../../core/services/add-new-client.service";
import { LoaderService } from "../../../../core/services/loader.service";
import {
  SharedService,
  getBase64,
} from "../../../../core/services/shared.service";
import { VendorService } from "../../../../core/services/vendor.service";
import { ClientPurposeType } from "../../../../shared/enums/clientpurposetype";
import { EnumContactType } from "../../../../shared/enums/enumContactType";
import { FileType } from "../../../../shared/enums/fileType";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { AddContactInformationComponent } from "../add-contact-information/add-contact-information.component";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { AddAddressInformationComponent } from "../add-address-information/add-address-information.component";
import { ViewAddressInformationComponent } from "../view-address-information/view-address-information.component";
import { ViewContactInformationComponent } from "../view-contact-information/view-contact-information.component";
import { Contact } from "../../../../core/models/shared/contact";
import { Vendor } from "../../../../core/models/vendor/addVendor/vendor";
import { VendorSummaryPODetail } from "../../../../core/models/vendor/summary/vendorSummaryPODetail";
import { VendorFeedbackRatingComponent } from "../vendor-feedback-rating/vendor-feedback-rating.component";
import { RatingModule, RatingRateEvent } from "primeng/rating";
import { PanelModule } from "primeng/panel";
import { InputTextModule } from "primeng/inputtext";
import { PopoverModule } from "primeng/popover";
import { ButtonModule } from "primeng/button";
import { TextareaModule } from "primeng/textarea";
import { CheckboxChangeEvent, CheckboxModule } from "primeng/checkbox";
import { RadioButtonModule } from "primeng/radiobutton";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { FileUploadEvent, FileUploadModule } from "primeng/fileupload";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { ClientAttachment } from "../../../../core/models/client/details/clientAttachment";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { VendorOpenLinesComponent } from "../vendor-open-lines/vendor-open-lines.component";
import { VendorOpenPoComponent } from "../vendor-open-po/vendor-open-po.component";

@UntilDestroy()
@Component({
  selector: "jni-vendor-summary",
  templateUrl: "./vendor-summary.component.html",
  styleUrls: ["./vendor-summary.component.scss"],
  providers: [DatePipe],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AddContactInformationComponent,
    AddAddressInformationComponent,
    ViewAddressInformationComponent,
    ViewContactInformationComponent,
    VendorFeedbackRatingComponent,
    RatingModule,
    PanelModule,
    InputTextModule,
    PopoverModule,
    ButtonModule,
    TextareaModule,
    CheckboxModule,
    RadioButtonModule,
    ScrollPanelModule,
    FileUploadModule,
    ModalStackerComponent,
    VendorOpenLinesComponent,
    VendorOpenPoComponent,
  ],
})
export class VendorSummaryComponent implements OnChanges, OnInit, OnDestroy {
  @Input() vendorObject!: Contact;
  @Output() closeModalOnOpenLinesEvent = new EventEmitter();
  @Output() closeModalOnOpenPOEvent = new EventEmitter();
  @Output() scrollHiddenStatus = new EventEmitter();

  public isCollapsed = false;
  public isCollapseOne = false;
  public isCollapseTwo = false;
  public isCollapseThree = false;
  public isCollapseFour = false;
  public isCollapseFive = false;
  isCollapseAll = true;

  collapseStatus = false;
  expandStatus = true;
  collapseHeading = "Collapse all";
  poLinesCount = 0;
  poHeadersCount = 0;
  scoreCount = 0;
  timeCount = 0;
  respCount = 0;
  totalCount = 0;

  lastPOdate = new Date();
  overAllScoreDate = new Date();
  vendorProfileCreatedDate = new Date();
  vendorName = "Golden Pacific Inc";
  overallScore = 0.0;
  nProduct = "Golden Pacific Products";
  vendorLink = "";
  vendorStatusId = "";
  vendorAttachment: VendorAttachments[] | undefined;
  w9AttachmentUrl = "https://www.irs.gov/pub/irs-pdf/fw9.pdf";
  uploadW9AttachmentUrl = "";
  vendorInformation?: VendorSummaryDto;
  vendorBasicInformation?: Vendor;
  vendorAddressInformation?: Address[];
  vendorContactsInformation?: Contact[];
  vendorAttachmentInformation?: VendorAttachments[];
  vendorPOInformation?: VendorSummaryPODetail = {};
  vendorContacts: Contact[] = [];
  vendorProfileArray: string[] = [];
  vendorProfileCsv!: string;
  ecoFriendlyStatus = false;
  bidOnlyStatus = false;
  madeinUSAStatus = false;
  bHUBZoneStatus = false;
  charityFriendly = false;
  minorityOwned = false;
  womenOwner = false;
  importer = false;
  promotional = false;
  smallBusiness = false;
  ownerIsAServiceVeteran = false;
  oneTimeSupplier = false;
  unionFriendly = false;
  ownerIsDisable = false;
  w9FileUrl?: GenericResponseDto<string>;
  files?: { w9File: string };
  fileObject: FileUploadDto[] = [];
  fileAttachment: ClientAttachment[] = [];
  w9FileName = "";
  w9FileValidationMessage = false;
  w9FileRemove = false;
  w9FileSize = false;
  w9fileSizeInKb = 1024;
  defaultW9fileName = "w9file";
  viewW9file = "";
  vendorFeedback: VendorFeedbackRequestDto = {} as VendorFeedbackRequestDto;
  isCriteriaSelected = false;
  respScore = 0;
  qualityScore = 0;
  timeScore = 0;
  feedbackScore: string | null = "0";
  notes: string | undefined = "";
  feedbackCriteria = "";
  vendorprofileCsv = "";
  qualityNotes: string | undefined = "";
  respNotes: string | undefined = "";
  timeNotes: string | undefined = "";
  currentlySelectedCriteria = "";
  businessObject: Contact[] | undefined;
  showSmallLoader = false;
  newVendorprofileArray: string[] = [];
  newVendorprofileCsv = "";
  showLastPODate = false;
  displayViewContact = false;
  displayAddContact = false;
  displayViewAddress = false;
  displayAddAddress = false;
  importUserRights = true;
  addressObject!: Address;
  contactheadingStatus = true;
  addressHeadingStatus = true;
  displayCreateAddress = false;
  vendorSummaryForm!: FormGroup;
  thumbStatus = false;
  vendorQualityFeedbackObject: VendorFeedback[] = [];
  vendorOnTimeFeedbackObject: VendorFeedback[] = [];
  vendorResponsiveFeedbackObject: VendorFeedback[] = [];
  userRoleId = 0;
  attachmentFileStatus = true;
  getProfileCsv = "";
  openPODisplayModal = false;
  openLinesDisplayModal = false;
  vendorModalStatus = false;
  loggedInUserIsAdmin = false;
  websiteLink = "";
  websiteLinkUrl = "";

  vendorFeedbackArray: { id: number; name: string }[] = [
    {
      id: 1,
      name: "quality",
    },
    {
      id: 2,
      name: "resp",
    },
    {
      id: 3,
      name: "time",
    },
  ];
  createdDate = "";
  createdDateName = "";
  lastModifiedName = "";
  lastModifiedDate = "";
  notesvalue = "";

  constructor(
    private router: ActivatedRoute,
    public datepipe: DatePipe,
    public _loaderService: LoaderService,
    private _addNewClientService: AddNewClientService,
    private _vendorService: VendorService,
    private _formBuilder: FormBuilder,
    private _toastr: JniToastrService,
    private _userManagementService: UserManagementService,
    private renderer: Renderer2,
    private _sharedService: SharedService
  ) {
    this.router.params.subscribe(params => {
      if (!this.vendorStatusId) {
        this.vendorStatusId = params["id"];
      }
    });

    this.vendorSummaryForm = this._formBuilder.group({
      vendorAccountNumber: [""],
      name: [""],
      phoneNumber: [""],
      emailAddress: [""],
    });
  }

  ngOnInit(): void {
    if (this.vendorStatusId) {
      this.getLoginUser();
      this.getVendorInformationData();
      this.getVendorTransactionCount();
    }
  }

  @Input() vendorIdFromModal = "";
  @Output() emitcloseVendorModalStacker = new EventEmitter();
  ngOnChanges() {
    if (this.vendorIdFromModal) {
      this.vendorStatusId = this.vendorIdFromModal;
      this.vendorModalStatus = true;
      //this.ngOnInit();
    }
  }

  closeOpenPOModal() {
    this.openPODisplayModal = false;
  }

  closeOpenLinesModal() {
    this.openLinesDisplayModal = false;
  }

  closeModalOnOpenLines(event: string) {
    this.openLinesDisplayModal = false;
    this.closeModalOnOpenLinesEvent.emit(event);
  }

  closeModalOnOpenPO(event: string) {
    this.openPODisplayModal = false;
    this.closeModalOnOpenPOEvent.emit(event);
  }

  getLoginUser() {
    this._userManagementService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        if (res.data) {
          this.userRoleId = res.data.userRoleId;
          if (this.userRoleId === UserRole.Admin) {
            this.loggedInUserIsAdmin = true;
          } else {
            this.loggedInUserIsAdmin = false;
          }

          if (
            this.userRoleId === UserRole.Admin ||
            this.userRoleId === UserRole.VR
          ) {
            this.importUserRights = false;
          } else {
            this.importUserRights = true;
          }
        }
      });
  }

  refreshSummary() {
    this.vendorContacts = [];
    this.vendorAddressInformation = [];
    this.ngOnInit();
  }
  viewContactInformation() {
    this.displayViewContact = true;
  }

  ViewAddressInformation() {
    this.displayViewAddress = true;
  }

  addContactInformation() {
    if (!this.importUserRights) {
      this.displayAddContact = true;
      this.contactheadingStatus = true;
    }
  }

  addAddressInformation() {
    this.displayAddAddress = true;
    this.addressHeadingStatus = true;
  }

  onEditAddress(addressObject: Address) {
    this.addressObject = addressObject;
    this.addressHeadingStatus = false;
    this.displayAddAddress = true;
  }

  onOpenEditContact(event: Contact) {
    this.onEditContact(event);
  }

  openEditAddress(event: Address) {
    this.onEditAddress(event);
  }

  onEditContact(contact: Contact) {
    if (!this.importUserRights) {
      this.vendorObject = contact;
      this.contactheadingStatus = false;
      this.displayAddContact = true;
    }
  }

  getVendorInformationData() {
    if (this.vendorStatusId) {
      this._loaderService.setLoaderState(true);
      this.showSmallLoader = true;
      this._vendorService
        .getVendorInformation(this.vendorStatusId?.toString())
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.vendorInformation = res.data;

            if (this.vendorInformation?.vendor) {
              this.vendorBasicInformation = this.vendorInformation?.vendor;
              this.patchVendorDateAndByValues();
            }
            if (this.vendorInformation?.contacts) {
              this.vendorContactsInformation = this.vendorInformation.contacts;
              const urlContact = this.vendorInformation.contacts.find(
                contact =>
                  contact.typeD365?.toLowerCase()?.includes("url") &&
                  (contact.isPrimaryD365?.toLowerCase() === "yes" ||
                    contact.isPrimaryD365 === "1")
              );
              if (urlContact) {
                this.vendorLink = urlContact.locatorD365 ?? "";
              }

              this.websiteLink =
                this.vendorInformation.contacts.find(
                  x => x.typeD365?.toLowerCase() === "url"
                )?.locatorD365 ?? "";
              this.websiteLinkUrl = this.websiteLink;
              if (this.websiteLink) {
                if (
                  this.websiteLink.includes("http://") &&
                  this.websiteLink.includes("https://")
                ) {
                  this.websiteLinkUrl = "http://" + this.websiteLink;
                }
              }
            }

            if (this.vendorInformation?.addresses) {
              this.vendorAddressInformation = this.vendorInformation?.addresses;
            }
            if (this.vendorInformation?.billingRepresentative) {
              this.patchValueInVendorRepresentativeSummary(
                this.vendorInformation?.billingRepresentative
              );
            }
            const lastOrderDate =
              this.vendorPOInformation?.lastOrderDate ?? "1900-01-01T00:00:00Z";

            const defaultDate = "1900-01-01T00:00:00Z";
            if (lastOrderDate > defaultDate) {
              this.showLastPODate = true;
            }
            this.vendorAttachment =
              this.vendorInformation?.vendorAttachments ?? undefined;
            if (this.vendorAttachment != undefined) {
              if (this.vendorAttachment.length > 0) {
                this.uploadW9AttachmentUrl =
                  this.vendorAttachment[0].notesD365 ?? "";
                this.thumbStatus = this.vendorAttachment[0].isActive;
                this.validationOnAttachmentFile();
              } else {
                this.attachmentFileStatus = false;
              }
            }
            this.vendorProfileCsv =
              this.vendorBasicInformation?.vendorProfile ?? "";
            this.getProfileCsv = this.vendorProfileCsv;
            this.commaSeparatedStringToArray();
            this.transformVendorContactData();
            this.getVendorFeedback();

            this._loaderService.setLoaderState(false);
            this.showSmallLoader = false;
          },
          error: () => {
            this._loaderService.setLoaderState(false);
            this.showSmallLoader = false;
          },
        });
    }
  }

  getVendorTransactionCount() {
    if (this.vendorStatusId) {
      this._vendorService
        .getVendorTransactionCount(this.vendorStatusId?.toString())
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res?.status?.toLowerCase() == "success" && res.data) {
              this.poLinesCount = res.data.lineCount;
              this.poHeadersCount = res.data.headerCount;
            }
          },
        });
    }
  }

  validationOnAttachmentFile() {
    let userObject;
    const userJson = localStorage.getItem("user");
    if (userJson) {
      userObject = JSON.parse(userJson);
      const useremail = userObject?.account?.username;
      if (
        (useremail === this.vendorBasicInformation?.createdBy &&
          this.uploadW9AttachmentUrl) ||
        (!this.importUserRights && this.uploadW9AttachmentUrl)
      ) {
        this.attachmentFileStatus = false;
      } else {
        this.attachmentFileStatus = true;
      }
    }
  }

  notesChange(event: Event) {
    const value = event.target as HTMLTextAreaElement;
    this.notesvalue = value?.value;
  }

  private getVendorFeedback() {
    if (this.vendorStatusId) {
      this.overallScore = 0;
      this._vendorService
        .getVendorFeedback(
          this.vendorStatusId,
          this.vendorBasicInformation?.vendorPartyNumberD365
        )
        .pipe(pluck("data"))
        .subscribe((feedbackList: VendorFeedbackDto) => {
          if (feedbackList?.qualityFeedback) {
            this.vendorQualityFeedbackObject = feedbackList.qualityFeedback;
            this.qualityScore = feedbackList.totalQualityRating ?? 0;
            this.scoreCount = feedbackList.qualityFeedback.length;
          }
          if (feedbackList?.timeFeedback) {
            this.vendorOnTimeFeedbackObject = feedbackList.timeFeedback;
            this.timeScore = feedbackList.totalTimeRating ?? 0;
            this.timeCount = feedbackList.timeFeedback.length;
          }
          if (feedbackList?.respFeedback) {
            this.vendorResponsiveFeedbackObject = feedbackList.respFeedback;
            this.respScore = feedbackList.totalRespRating ?? 0;
            this.respCount = feedbackList.respFeedback.length;
          }
          if (feedbackList?.totalRating) {
            this.overallScore = feedbackList.totalRating ?? 0;
            this.totalCount = this.scoreCount + this.timeCount + this.respCount;
          }
        });
    }
  }

  transformVendorContactData() {
    this.vendorContacts = [];
    const Vendor = this.vendorContactsInformation?.filter(
      x => x.purposeD365 == ClientPurposeType.Business
    );
    //this.populateVendorContactInformation(Vendor);
    this.groupByContactArray(Vendor);

    // const Inside = this.vendorContactsInformation?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Invoice
    // );
    // this.populateVendorContactInformation(Inside);
    const Website = this.vendorContactsInformation?.filter(
      x => x.purposeD365 == ClientPurposeType.Other
    );

    const inside = Website?.filter(x => x.otherSpecification === "Inside");
    this.groupByContactArray(inside);
    //this.populateVendorContactInformation(inside);

    const newwebsite = Website?.filter(x => x.otherSpecification === "Website");
    this.groupByContactArray(newwebsite);
    //this.populateVendorContactInformation(newwebsite);
  }

  groupByContactArray(contactArray: Contact[] | undefined) {
    const array: Contact[] | undefined = [];

    if (contactArray?.length) {
      for (let i = 0; i < contactArray.length; i++) {
        array.push(contactArray[i]);

        if (i % 2 !== 0) {
          this.populateVendorContactInformation(array);
          array.length = 0;
        }
      }

      if (array.length) {
        this.populateVendorContactInformation(array);
      }
    }
  }

  criteriaChanged(name: string) {
    this.isCriteriaSelected = true;
    this.currentlySelectedCriteria = name;
    this.feedbackScore = this.score;
    // if (name == 'quality') {
    //   this.feedbackScore = this.qualityScore;
    // } else if (name == 'time') {
    //   this.feedbackScore = this.timeScore;
    // } else if (name == 'resp') {
    //   this.feedbackScore = this.respScore;
    // }
  }

  populateVendorContactInformation(vendorContacts: Contact[] | undefined) {
    if (
      vendorContacts != null &&
      vendorContacts != undefined &&
      vendorContacts.length > 0
    ) {
      const vendorContact: Contact = {
        otherSpecification: "",
        createdDate: "",
        createdBy: "",
        lastModifiedDate: null,
        lastModifiedBy: null,
        isActive: false,
      };
      const name = vendorContacts[0]?.firstNameD365;
      vendorContact.purposeD365 = vendorContacts[0].purposeD365;
      vendorContact.isPrimaryD365 = vendorContacts[0].isPrimaryD365;
      vendorContact.nameD365 =
        vendorContacts[0].descriptionD365 === ""
          ? name
          : vendorContacts[0].descriptionD365;
      // vendorAddress.electronicAddressIdD365 =
      //   vendorContacts[0].electronicAddressIdD365;
      vendorContact.otherSpecification =
        vendorContacts[0].otherSpecification ?? "";
      if (
        vendorContacts.find(x => x.typeD365 == EnumContactType.Phone) !=
        undefined
      ) {
        vendorContact.phone = vendorContacts.find(
          x => x.typeD365 == EnumContactType.Phone
        )?.locatorD365;
        vendorContact.phoneLink =
          "tel:'" +
          vendorContacts.find(x => x.typeD365 == EnumContactType.Phone)
            ?.locatorD365 +
          "'";
        vendorContact.electronicAddressPhone = vendorContacts.find(
          x =>
            x.typeD365 == EnumContactType.Phone &&
            x?.electronicAddressIdD365 !== ""
        )?.electronicAddressIdD365;

        vendorContact.portalKeyPhone = vendorContacts.find(
          x => x.typeD365 == EnumContactType.Phone && x?.portalKeyD365 !== ""
        )?.portalKeyD365;
      }
      if (
        vendorContacts.find(x => x.typeD365 == EnumContactType.Email) !=
        undefined
      ) {
        vendorContact.email = vendorContacts.find(
          x => x.typeD365 == EnumContactType.Email
        )?.locatorD365;
        vendorContact.emailLink =
          "mailto:'" +
          vendorContacts.find(x => x.typeD365 == EnumContactType.Email)
            ?.locatorD365 +
          "'";
        vendorContact.electronicAddressEmail = vendorContacts.find(
          x =>
            x.typeD365 == EnumContactType.Email &&
            x?.electronicAddressIdD365 !== ""
        )?.electronicAddressIdD365;
      }

      vendorContact.portalKeyEmail = vendorContacts.find(
        x => x.typeD365 == EnumContactType.Email && x?.portalKeyD365 !== ""
      )?.portalKeyD365;

      this.vendorContacts.push(vendorContact);
    }

    if (this.vendorContacts != undefined) {
      if (this.vendorContacts.length > 0) {
        this.businessObject = this.vendorContacts.filter(
          x => x.purposeD365 === "Business"
        );
      }
    }
  }

  patchValueInVendorRepresentativeSummary(
    vendorContact: BillingRepresentative
  ) {
    if (vendorContact) {
      this.vendorSummaryForm.patchValue({
        name: vendorContact.name,
        phoneNumber: vendorContact.phoneNumber,
        emailAddress: vendorContact.emailAddress,
      });
    }
  }

  commaSeparatedStringToArray() {
    this.vendorProfileArray = this.vendorProfileCsv?.split(",");

    if (this.vendorProfileArray.length > 0) {
      const ecofrindly = this.vendorProfileArray
        .filter(x => x == "Eco-Friendly Business")
        .toString();
      this.ecoFriendlyStatus = ecofrindly != "" ? true : false;

      const bidonly = this.vendorProfileArray
        .filter(x => x == "Bid-Only")
        .toString();
      this.bidOnlyStatus = bidonly != "" ? true : false;

      const madeinusa = this.vendorProfileArray
        .filter(x => x == "Made in USA")
        .toString();
      this.madeinUSAStatus = madeinusa != "" ? true : false;

      const bzone = this.vendorProfileArray
        .filter(x => x == "BHUBZone")
        .toString();
      this.bHUBZoneStatus = bzone != "" ? true : false;

      const charityfriendly = this.vendorProfileArray
        .filter(x => x == "Charity Friendly")
        .toString();
      this.charityFriendly = charityfriendly != "" ? true : false;
    }
    const minorityowned = this.vendorProfileArray
      .filter(x => x == "Minority Owned")
      .toString();
    this.minorityOwned = minorityowned != "" ? true : false;

    const womenowner = this.vendorProfileArray
      .filter(x => x == "Women Owner")
      .toString();
    this.womenOwner = womenowner != "" ? true : false;

    const imposter = this.vendorProfileArray
      .filter(x => x == "Importer")
      .toString();
    this.importer = imposter != "" ? true : false;

    const promotional = this.vendorProfileArray
      .filter(x => x == "Promotional")
      .toString();
    this.promotional = promotional != "" ? true : false;

    const smallbusiness = this.vendorProfileArray
      .filter(x => x == "Small Business")
      .toString();
    this.smallBusiness = smallbusiness != "" ? true : false;

    const serviceveteran = this.vendorProfileArray
      .filter(x => x == "Owner is a service veteran")
      .toString();
    this.ownerIsAServiceVeteran = serviceveteran != "" ? true : false;

    const onetimesupplier = this.vendorProfileArray
      .filter(x => x == "One Time Supplier")
      .toString();
    this.oneTimeSupplier = onetimesupplier != "" ? true : false;

    const unionfriendly = this.vendorProfileArray
      .filter(x => x == "Union Friendly")
      .toString();
    this.unionFriendly = unionfriendly != "" ? true : false;

    const ownerdisabled = this.vendorProfileArray
      .filter(x => x == "Owner is disable")
      .toString();
    this.ownerIsDisable = ownerdisabled != "" ? true : false;
  }

  async getVendorW9Upload(event: FileUploadEvent) {
    //const target = file.target as HTMLInputElement;
    this.fileAttachment = [];
    this.fileObject = [];
    if (event.files && event.files.length > 0) {
      const fileObj = event?.files[0];
      const filesize = Math.round(fileObj.size / this.w9fileSizeInKb);
      if (filesize <= this.w9fileSizeInKb) {
        this.w9FileName = fileObj.name;
        const fileextension =
          "." + fileObj?.name?.split(".")?.pop()?.toLowerCase();
        await getBase64(fileObj).then(data => {
          const base64 = data as string;
          this.createAttachmentFileObject(
            this.defaultW9fileName,
            FileType.url,
            base64
          );
          this.createFileUploadDto(
            base64,
            this.defaultW9fileName,
            fileextension,
            filesize,
            fileObj.type
          );
        });
        this.w9FileValidationMessage = false;
        this.w9FileRemove = true;
        this.w9FileSize = false;
      } else {
        this.w9FileSize = true;
      }
      if (this.fileAttachment.length > 0) {
        this.fileAttachment = this.fileAttachment.slice(-2);
        await this.getAttachmentUrlData(this.fileObject);
        this.fileAttachment.map(obj => {
          if (obj.descriptionD365 == this.defaultW9fileName) {
            obj.notesD365 = this.files?.w9File;
          }
          const fileObject: ClientAttachment = {
            typeIdD365: this.fileAttachment[0].typeIdD365,
            descriptionD365: this.fileAttachment[0].descriptionD365,
            notesD365: this.fileAttachment[0].notesD365,
            restrictionD365: this.fileAttachment[0].restrictionD365,
            partyNumberD365: this.vendorBasicInformation?.vendorPartyNumberD365,
            customerAccountD365: this.vendorStatusId,
            // createdDate: "",
            // createdBy: "",
            // lastModifiedDate: null,
            // lastModifiedBy: null,
            // isActive: false,
          };
          this.uploadW9FileOnSummary(fileObject);
        });
      }
    }
  }

  getCurrentRating() {
    // if (this.currentlySelectedCriteria == 'quality') {
    //   return parseInt(this.qualityScore ? this.qualityScore : '0');
    // } else if (this.currentlySelectedCriteria == 'resp') {
    //   return parseInt(this.respScore ? this.respScore : '0');
    // } else if (this.currentlySelectedCriteria == 'time') {
    //   return parseInt(this.timeScore ? this.timeScore : '0');
    // }
    if (this.score) {
      return parseInt(this.score ? this.score : "0");
    } else {
      return parseInt("0");
    }
  }

  score = "";
  feedbackLeave(event: RatingRateEvent) {
    this.score = event?.value.toString();
    // if (this.currentlySelectedCriteria == 'quality') {
    //   this.qualityScore = event;
    // } else if (this.currentlySelectedCriteria == 'time') {
    //   this.timeScore = event;
    // } else if (this.currentlySelectedCriteria == 'resp') {
    //   this.respScore = event;
    // }
  }

  uploadW9FileOnSummary(obj: ClientAttachment) {
    this._loaderService.setLoaderState(true);
    this._vendorService
      .uploadW9FileOnSummary(obj)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.status.toLowerCase() == "success") {
            this.uploadW9AttachmentUrl = res.data.notesD365 ?? "";

            //Save file in D365
            this.uploadW9FileOnD365(obj);

            this.w9FileName = "";
            this.thumbStatus = res.data.isActive || false;
          } else {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message);
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Failed To Upload Attachement"
          );
        },
      });
  }

  createAttachmentFileObject(name: string, extension: string, data: string) {
    this.fileAttachment.push({
      typeIdD365: extension,
      notesD365: data,
      restrictionD365: 1,
      descriptionD365: name,
      // createdDate: "",
      // createdBy: "",
      // lastModifiedDate: null,
      // lastModifiedBy: null,
      // isActive: false,
    });
  }

  getRating(score: string | null) {
    return parseInt(score ?? "0");
  }

  createFileUploadDto(
    data: string,
    name: string,
    extension: string,
    size: number,
    filemimetype: string
  ) {
    const base64File = data.split(",")[1];
    this.fileObject.push({
      base64: base64File,
      fileName: name,
      fileExtension: extension,
      fileSize: size,
      fileMimeType: filemimetype,
    });
  }

  feedbackSubmit() {
    this._loaderService.setLoaderState(true);
    const vendorFeedback: VendorFeedbackRequestDto[] = [];
    if (this.currentlySelectedCriteria === "quality") {
      const qualityObject = {
        accountNumber: this.vendorStatusId,
        partyNumber: this.vendorBasicInformation?.vendorPartyNumberD365 ?? "",
        criteria: "quality",
        score: this.score === "" ? 0 : parseFloat(this.score),
        notes: this.notesvalue ? this.notesvalue : "",
      };
      vendorFeedback.push(qualityObject);
    } else if (this.currentlySelectedCriteria === "resp") {
      const resp = {
        accountNumber: this.vendorStatusId,
        partyNumber: this.vendorBasicInformation?.vendorPartyNumberD365 ?? "",
        criteria: "resp",
        score: this.score === "" ? 0 : parseFloat(this.score),
        notes: this.notesvalue ? this.notesvalue : "",
      };
      vendorFeedback.push(resp);
    } else if (this.currentlySelectedCriteria === "time") {
      const time = {
        accountNumber: this.vendorStatusId,
        partyNumber: this.vendorBasicInformation?.vendorPartyNumberD365 ?? "",
        criteria: "time",
        score: this.score === "" ? 0 : parseFloat(this.score),
        notes: this.notesvalue ? this.notesvalue : "",
      };
      vendorFeedback.push(time);
    }
    this._vendorService
      .AddVendorFeedback(vendorFeedback)
      .pipe(pluck("data"))
      .subscribe(() => {
        this._loaderService.setLoaderState(false);
        this._toastr.success("Success", "Feedback submitted");
        this.overallScore = 0;
        this.notesvalue = "";
        this.feedbackScore = "";
        this.score = "";
        this.feedbackCriteria = "";
        this.isCriteriaSelected = false;
        this.getVendorFeedback();
      });
  }

  async getAttachmentUrlData(attachment: FileUploadDto[]) {
    const w9Obj = attachment.filter(x => x.fileName === this.defaultW9fileName);
    if (w9Obj.length > 0) {
      this.w9FileUrl = await lastValueFrom(
        this._addNewClientService.getRescaleAttachmentUrl(w9Obj)
      );
    }
    this.files = {
      w9File: this.w9FileUrl != undefined ? this.w9FileUrl.data : "",
    };
  }

  venderprofileCheckboxButton(event: CheckboxChangeEvent) {
    const value = event.checked as boolean;
    const target = event?.originalEvent?.target as HTMLInputElement;

    this.showSmallLoader = true;
    if (value) {
      this.newVendorprofileArray.push(target?.name);
    } else {
      this.getProfileCsv = this.getProfileCsv.replace(target?.name + ",", "");
      this.getProfileCsv = this.getProfileCsv.replace("," + target?.name, "");
      const index = this.newVendorprofileArray.indexOf(target?.name);
      if (index !== -1) {
        this.newVendorprofileArray.splice(index, 1);
      }
    }

    this.newVendorprofileCsv = this.newVendorprofileArray.toString();

    const updateCsv = this.getProfileCsv + "," + this.newVendorprofileCsv;
    this.updateCsvCheckBox(updateCsv);
  }

  updateCsvCheckBox(vendorprofileCsv: string) {
    const payload = {
      vendorAccount: this.vendorStatusId,
      vendorProfile: vendorprofileCsv,
    };
    this._vendorService
      .updateVendorSummaryCsv(payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  onToggle() {
    if (this.isCollapseAll) {
      this.isCollapsed = true;
      this.isCollapseOne = true;
      this.isCollapseTwo = true;
      this.isCollapseThree = true;
      this.isCollapseFour = true;
      this.isCollapseFive = true;
      this.isCollapseAll = false;
      this.collapseStatus = true;
      this.collapseHeading = "Expand all";
    } else {
      this.collapseStatus = false;
      this.isCollapsed = false;
      this.isCollapseOne = false;
      this.isCollapseTwo = false;
      this.isCollapseThree = false;
      this.isCollapseFour = false;
      this.isCollapseFive = false;
      this.isCollapseAll = true;
      this.collapseHeading = "Collapse all";
    }
  }

  openLinesPage() {
    this.openLinesDisplayModal = true;
    //this._router.navigate(['/vendors/open-lines/' + this.vendorStatusId]);
  }

  openPoPage() {
    this.openPODisplayModal = true;
    //this._router.navigate(['/vendors/open-po/' + this.vendorStatusId]);
  }

  updateVendorSummaryData() {
    this._loaderService.setLoaderState(true);
    const vendorSummaryForm =
      this.vendorSummaryForm.getRawValue() as BillingRepresentative;
    if (this.vendorStatusId) {
      vendorSummaryForm.vendorAccountNumber = this.vendorStatusId;
    }
    this._vendorService
      .UpdateVendorSummaryData(vendorSummaryForm)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (!res.data) {
            this._toastr.error("Error", res.message || "Error updating vendor");
          } else {
            this._toastr.success("Success", "Vendor update successfully");
            this.getVendorInformationData();
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error updating vendor");
        },
      });
  }

  onDisabledFeedback(vendorFeedbackObject: VendorFeedback) {
    this._vendorService
      .UpdateVendorCommentStatus(vendorFeedbackObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (!res.data) {
            this._toastr.error(
              "Error",
              res.message || "Error setting feedback visibility"
            );
          } else {
            this._toastr.success("Success", "Feedback visibility set");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error setting feedback visibility"
          );
        },
      });
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  addScollHiddenClass() {
    if (this.vendorModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    }
  }

  uploadW9FileOnD365(obj: ClientAttachment) {
    this._loaderService.setLoaderState(true);
    const d365obj: CreateAttachmentRequestDto = {
      FileName: "w9file",
      FileExtension: ".pdf",
      FileContent: obj.notesD365 ?? "",
      LineNum: 0,
      Id: obj.customerAccountD365 ?? "",
      DocumentType: 6, // For Vendors
      Restriction: 0,
      PortalKey: uuidv4(),
      Notes: obj.notesD365 ?? "",
      AttachmentName: obj.descriptionD365 ?? "",
      AttachmentTypeId: "URL",
    };
    this._vendorService
      .uploadW9FileOnD365(d365obj)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() == "success") {
            this._toastr.success("Success", res.message);
          } else {
            this._toastr.error("Error", res.message);
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Failed To Upload Attachement In D365"
          );
        },
      });
  }

  patchVendorDateAndByValues() {
    if (this.vendorBasicInformation?.lastModifiedDate) {
      this.lastModifiedDate = this.vendorBasicInformation?.lastModifiedDate;
      const modifiedNameList =
        this.vendorBasicInformation?.lastModifiedBy?.split("@") ?? "";
      if (modifiedNameList?.length > 1) {
        this.lastModifiedName = modifiedNameList[0];
      }
    }
    if (this.vendorBasicInformation?.createdDate) {
      this.createdDate = this.vendorBasicInformation?.createdDate;
      const createdByList =
        this.vendorBasicInformation?.createdBy?.split("@") ?? "";
      if (createdByList.length > 1) {
        this.createdDateName = createdByList[0];
      }
    }
  }

  closeVendorModalStacker() {
    this.emitcloseVendorModalStacker.emit();
  }

  fileDownload(url: string) {
    this._sharedService.getFileAsBlob(url).subscribe({
      next: res => {
        const blob = new Blob([res], { type: res.type });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      },
    });
  }
}
